const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

function available() {
  return !!GA_ID && typeof window !== "undefined" && typeof window.gtag === "function";
}

export function trackPageView(path) {
  if (!available()) return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.origin + path,
    page_path: path,
  });
}

export function trackEvent(name, params = {}) {
  if (!available()) return;
  window.gtag("event", name, params);
}
